export default {
      id: "wizard-sensors-usage",
      viewBox: "0 0 45 32",
      url: __webpack_public_path__ + "img/icons.svg#wizard-sensors",
      toString: function () {
        return this.url;
      }
    }